export const CONTENT_MAX_WIDTH = 1376;
export const DASHBOARD_CONTENT_MAX_WIDTH = 1440;
export const MOBILE_MAX_WIDTH = 480;

export const GOV_FRAMEWORK_URL =
  'https://www.gov.uk/government/publications/essential-digital-skills-framework';

export const SSO_LOGIN_PATH = '/api/auth/login';
